import { defineMasterdataEntity } from '../types/masterdata-entity-definition';
import { MasterdataCollector } from '../types/masterdata-entities';

export const MASTERDATA_COLLECTOR = defineMasterdataEntity<MasterdataCollector>({
  name: 'collector',
  responseKey: 'collectors',
  displayWith: (c) => c.name ?? '',
  secondaryWith: (c) => c.dateOfBirth,
  icon: 'fa-regular fa-hand-holding-box',
  title: 'Abholersuche',
  label: 'Abholer',
  placeholder: 'Abholer suchen...',
  columns: [
    {
      label: 'Abholer',
      type: 'entity',
      icon: 'fa-regular fa-hand-holding-box',
      value: (c) => c.name ?? '',
      secondary: (c) => c.dateOfBirth,
    },
    { label: 'Bezeichnung', type: 'text', value: (c) => c.name },
    { label: 'Geburtsdatum', type: 'text', value: (c) => c.dateOfBirth },
  ],
});
